import axios from "axios";
import { GURL } from "./global";

export const AddNoticeLevelService = (
  order: any,
  level: any,
  noticeId: any
) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/AddNoticeLevel`;
  return axios.post(url, { order, level, noticeId });
};

export const GetNoticeLevelsByNoticeId = (noticeId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/NoticeLevelsByNoticeId?NoticeId=${noticeId}`;
  return axios.get(url);
};

export const RemoveNoticeLevelService = (id: any, noticeId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/RemoveNoticeLevel`;
  return axios.post(url, { id, noticeId });
};
